export const changeDotWithComma = value => value.toString().replaceAll('.', ',');

export const changeCommaWithDot = value => Number(value.toString().replaceAll(',', '.'));
